import { tableTestSearchData } from '../components/custom/TestResultTable'
import type { GetSearchParams } from './apiTypes'

/** The fake apiGetSearchData */
export const apiGetSearchData = async (params: GetSearchParams) => {
  const data = tableTestSearchData.slice(0, params.size)
  return data
}
